import {useState, useRef, useEffect} from 'react';
import {Row, Col, Button, Collapse} from 'react-bootstrap';
import IminioTextField from '../iminio_comps/fields/IminioTextField'
import { iminioBackend } from '../../api/iminio_provider';
import i18n from '../../plugins/i18n';


function ProfileForm({ userInfo, onUpdateName}) {

    // const [email, setEmail] = useState("");
    const [userFullname, setUserFullname] = useState('')
    const [isLoading, setLoading] = useState(false);
    const [isChangingPassword, setChangingPassword] = useState(false);
    const [isChangingEmail, setChangingEmail] = useState(false);
    const [isChangingName, setChangingName] = useState(false);
    const [showError, setShowError] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    const [errorText, setErrorText] = useState("");
    const [messageText, setMessageText] = useState("");

    const emailFieldRef = useRef("")
    const passwordFieldRef = useRef("")
    const repeatPasswordFieldRef = useRef("")
    const firstNameFieldRef = useRef("")
    const lastNameFieldRef = useRef("")

    const switchChangingPassword = (val) => {
        passwordFieldRef.current = ""
        repeatPasswordFieldRef.current = ""
        setChangingPassword(val)
    }

    const onChangingEmail = () => {
        emailFieldRef.current.focus()
        setChangingEmail(true)
    }

    const onChangingName = () => {
        firstNameFieldRef.value = userInfo.first_name
        lastNameFieldRef.value = userInfo.last_name
        setChangingName(true)
    }

    const cancelChangingEmail = () => {
        emailFieldRef.current.value = userInfo.email
        setChangingEmail(false)
    }

    const submitChangePassword = async () => {
        setShowError(false)
        setLoading(true)
        await iminioBackend.change_password(
            passwordFieldRef.current.value, 
            repeatPasswordFieldRef.current.value
        ).then(
            response=>{
                localStorage.removeItem('access')
                localStorage.removeItem('refresh')
                setTimeout(()=>{window.location.assign('/login')},300)
            }
        ).catch(e=>{
            if(e?.response?.data?.status?.code === "ERR_INVALID_CREDENTIALS")
                setErrorText(i18n.t("errors.ERR_INVALID_PASSWORD"))
            setTimeout(() => {setLoading(false)}, 300);
            setTimeout(()=>setShowError(true), 300)
        })
    }

    const submitChangeName = async () => {
        setShowError(false)
        setLoading(true)
        await iminioBackend.update_me(
            {
                first_name: firstNameFieldRef.current.value,
                last_name: lastNameFieldRef.current.value
            }
         ).then(
             response=>{
                userInfo = response.me
                onUpdateName(response.me)
                setUserFullname(`${response.me.first_name} ${response.me.last_name}`)
                setMessageText(i18n.t('messages.saved_success').replace('{1}', 'Nome e Cognome'))
                setTimeout(() => {setShowMessage(true)}, 150);
                setTimeout(() => {setLoading(false)}, 300);
                setTimeout(() => {cancelChangingName()}, 300);
                setTimeout(() => {setShowMessage(false)}, 3700);
             }
         ).catch(e=>{
             if(e?.response?.data?.status?.code === "ERR_INVALID_CREDENTIALS")
                 setErrorText(i18n.t("errors.ERR_INVALID_PASSWORD"))
            else setErrorText(i18n.t("errors.unknown"))
             setTimeout(() => {setLoading(false)}, 300);
             setTimeout(()=>setShowError(true), 300)
         })   
    }

    const cancelChangingName = () => {
        setChangingName(false)
    }

    const submitChangeEmail = async () => {
        setShowError(false)
        setLoading(true)
        await iminioBackend.update_me(
           {email: emailFieldRef.current.value}
        ).then(
            response=>{
                userInfo = response.me
                setMessageText(i18n.t('messages.saved_success').replace('{1}', 'Email'))
                setTimeout(() => {setShowMessage(true)}, 150);
                setTimeout(() => {setLoading(false)}, 300);
                setTimeout(() => {setChangingEmail(false)}, 300);
                setTimeout(() => {setShowMessage(false)}, 3700);
            }
        ).catch(e=>{
            if(e?.response?.data?.status?.code === "ERR_INVALID_CREDENTIALS")
                setErrorText(i18n.t("errors.ERR_INVALID_PASSWORD"))
            setTimeout(() => {setLoading(false)}, 300);
            setTimeout(()=>setShowError(true), 300)
        })
    }

    const buildFullName = () => {
        return `${userInfo.first_name} ${userInfo.last_name}`
    }

    useEffect(()=>{
        setUserFullname(buildFullName())
    }, [])

    return <> 
        <Col xs={12} className={'col'}>
            <Row className={'d-flex justify-content-center align-items-center, align-content-center mt-5 pt-2'}>
                <Col xs={12} md={6} className={'d-flex justify-content-center align-items-center align-content-center'}>
                    <h2 className={isChangingPassword || isChangingEmail ? '' : `ms-4`}>
                        { isChangingName? 'Cambiando Nome' : userFullname}
                    </h2>
                    {isChangingPassword || isChangingEmail ? '' : 
                        isChangingName===true ? '' :<i className="mdi mdi-pencil text-10 ms-2 profile-form-fullname-edit-icon" onClick={()=>onChangingName()} ></i>
                    }
                </Col>
            </Row>
            <Row className={'d-flex justify-content-center align-items-center, align-content-center mt-2'}>
                <Col xs={6} className={'d-flex justify-content-center align-items-center, align-content-center'}>
                    <i className="mdi mdi-account-circle text-54 fg-orange"></i>
                </Col>
            </Row>
            <Row className={'d-flex justify-content-center align-items-center, align-content-center'}>
                <Col xs={12} sm={6} md={5} className={'d-flex justify-content-center align-items-center, align-content-center'}>
                    <Collapse in={showError}>
                        <Row className="justify-content-center">
                            <Col id="sing-in-error-container" className="bg-orange-dark d-flex justify-content-center py-1 px-3 iminio-border-round">
                                <Row className="justify-content-center"><span className="fg-white justify-content-center">{errorText}</span></Row>
                            </Col>
                        </Row>
                    </Collapse>
                    <Collapse in={showMessage}>
                        <Row className="justify-content-center">
                            <Col id="sing-in-error-container" className="bg-green d-flex justify-content-center py-1 px-3 iminio-border-round">
                                <Row className="justify-content-center"><span className="fg-white justify-content-center">{messageText}</span></Row>
                            </Col>
                        </Row>
                    </Collapse>
                </Col>
            </Row>
            {
                isChangingPassword === true ?    
                <>
                    <Row className="pt-3 justify-content-center align-items-center" xs={12}>
                        <Col xs={12} sm={6} md={3}>
                            <IminioTextField 
                                id="profile-form-password"
                                placeholder={i18n.t('words.current_password')}
                                innerRef={passwordFieldRef} 
                                defaultValue=''
                                textAlign="start"
                                disabled={isLoading===true}
                                type="password"
                            />
                        </Col>
                    </Row>
                    <Row className="pt-3 justify-content-center align-items-center" xs={12}>
                        <Col xs={12} sm={6} md={3}>
                            <IminioTextField 
                                id="profile-form-confirm-password"
                                placeholder={i18n.t('words.new_password')}
                                innerRef={repeatPasswordFieldRef} 
                                defaultValue=''
                                textAlign="start"
                                disabled={isLoading===true}
                                type="password"
                            />
                        </Col>
                    </Row>
                </>
                :
                isChangingName ? <>
                    <Row className="pt-3 justify-content-center align-items-center" xs={12}>
                        <Col xs={12} sm={6} md={3} className="ps-2" style={{position:"relative"}}>
                            <b>Nome</b>
                        </Col>
                    </Row>
                    <Row className="justify-content-center align-items-center" xs={12}>
                        <Col xs={12} sm={6} md={3} style={{position:"relative"}}>
                            <IminioTextField 
                                id="profile-form-first_name"
                                placeholder="Nome" 
                                innerRef={firstNameFieldRef} 
                                defaultValue={userInfo.first_name}
                                textAlign="center"
                                disabled={isLoading===true}
                            />
                        </Col>
                    </Row>
                    <Row className="pt-3 justify-content-center align-items-center" xs={12}>
                        <Col xs={12} sm={6} md={3} className="ps-2" style={{position:"relative"}}>
                            <b>Cognome</b>
                        </Col>
                    </Row>    
                    <Row className="justify-content-center align-items-center" xs={12}>
                        <Col xs={12} sm={6} md={3} style={{position:"relative"}}>
                            <IminioTextField 
                                id="profile-form-last_name"
                                placeholder="Cognome" 
                                innerRef={lastNameFieldRef} 
                                defaultValue={userInfo.last_name}
                                textAlign="center"
                                disabled={isLoading===true}
                            />
                        </Col>
                    </Row>
                </>
                :
                <Row className="pt-3 justify-content-center align-items-center" xs={12}>
                    <Col xs={12} sm={6} md={3} style={{position:"relative"}}>
                        <IminioTextField 
                            id="profile-form-email"
                            placeholder="Email" 
                            innerRef={emailFieldRef} 
                            defaultValue={userInfo.email}
                            readOnly={!isChangingEmail}
                            textAlign="center"
                            disabled={isLoading===true}
                        />
                        {
                            isChangingEmail ? '' :
                            <i className="mdi mdi-pencil text-10 profile-form-email-edit-icon" onClick={()=>onChangingEmail()} ></i>
                        }
                    </Col>
                </Row>
            }
            {
                isChangingPassword ? <>
                    <Row className="pt-3 justify-content-center align-items-center">
                        <Col xs={12} sm={6} md={3} className="d-flex justify-content-center align-items-center">
                            <Button className={`px-3 corner-round bg-orange fg-white width-100`} variant="orange" disabled={isLoading} onClick={()=>{submitChangePassword()}}>
                                <i className="mdi mdi-content-save me-2"></i>
                                {i18n.t('actions.save')}
                            </Button>
                        </Col>
                    </Row>
                    <Row className="pt-3 justify-content-center align-items-center">
                        <Col xs={12} sm={6} md={3} className="d-flex justify-content-center align-items-center">
                            <Button className={`px-3 corner-round bg-gray-dark fg-black width-100`} variant="orange" disabled={isLoading} onClick={()=>{switchChangingPassword(false)}}>
                                <i className="mdi mdi-close me-2"></i>
                                {i18n.t('actions.cancel')}
                            </Button>
                        </Col>
                    </Row>
                </> :
                (isChangingEmail ?
                    <>
                        <Row className="pt-3 justify-content-center align-items-center">
                        <Col xs={12} sm={6} md={3} className="d-flex justify-content-center align-items-center">
                            <Button className={`px-3 corner-round bg-orange fg-white width-100`} variant="orange" disabled={isLoading} onClick={()=>{submitChangeEmail()}}>
                                <i className="mdi mdi-content-save me-2"></i>
                                {i18n.t('actions.save')}
                            </Button>
                        </Col>
                        </Row>
                        <Row className="pt-3 justify-content-center align-items-center">
                            <Col xs={12} sm={6} md={3} className="d-flex justify-content-center align-items-center">
                                <Button className={`px-3 corner-round bg-gray-dark fg-black width-100`} variant="orange" disabled={isLoading} onClick={()=>{cancelChangingEmail(false)}}>
                                    <i className="mdi mdi-close me-2"></i>
                                    {i18n.t('actions.cancel')}
                                </Button>
                            </Col>
                        </Row>
                    </>
                :
                isChangingName ?
                    <>
                        <Row className="pt-3 justify-content-center align-items-center">
                        <Col xs={12} sm={6} md={3} className="d-flex justify-content-center align-items-center">
                            <Button className={`px-3 corner-round bg-orange fg-white width-100`} variant="orange" disabled={isLoading} onClick={()=>{submitChangeName()}}>
                                <i className="mdi mdi-content-save me-2"></i>
                                {i18n.t('actions.save')}
                            </Button>
                        </Col>
                        </Row>
                        <Row className="pt-3 justify-content-center align-items-center">
                            <Col xs={12} sm={6} md={3} className="d-flex justify-content-center align-items-center">
                                <Button className={`px-3 corner-round bg-gray-dark fg-black width-100`} variant="orange" disabled={isLoading} onClick={()=>{cancelChangingName()}}>
                                    <i className="mdi mdi-close me-2"></i>
                                    {i18n.t('actions.cancel')}
                                </Button>
                            </Col>
                        </Row>
                    </>
                    :
                <Row className="pt-3 justify-content-center align-items-center">
                    <Col xs={12} sm={6} md={3} className="d-flex justify-content-center align-items-center">
                        <Button className={`px-3 corner-round bg-orange fg-white width-100`} variant="orange" disabled={isLoading} onClick={()=>{switchChangingPassword(true)}}>
                            <i className="mdi mdi-key me-2"></i>
                            {i18n.t('actions.change_password')}
                        </Button>
                    </Col>
                </Row>
                )
            }
        </Col>
    </>;
}

export default ProfileForm